import { render, staticRenderFns } from "./ErrorPage404.vue?vue&type=template&id=7905bc60&scoped=true&"
import script from "./ErrorPage404.vue?vue&type=script&lang=js&"
export * from "./ErrorPage404.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPage404.vue?vue&type=style&index=0&id=7905bc60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7905bc60",
  null
  
)

export default component.exports